import React, { useEffect, useState, useCallback } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useSelector } from "react-redux";
import { TbPlus } from "react-icons/tb";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";
import { Link } from "react-router-dom";

function Frame(props) {
return (
    <div>
      <Animation
        animationIn={animationStyles.fadeIn}
        animationOut={animationStyles.fadeOut}
      >
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Шаблоны документов</h5>
            </div>
          </CardHeader>
          <CardBody>
            <Link to="/data/project-contract-with-schools.docx" text-decoration-none target="_blank">
            <Card>
              <CardBody>
                <div>
                  <p>Проект договора со школами</p>
                </div>
              </CardBody>
            </Card>
            </Link>
            <Link to="/data/practice-contract-between-employer-and-educational-organization.rtf" text-decoration-none target="_blank">
            <Card>
              <CardBody>
                <div>
                  <p>Договор по практике между работодателем и образоват_организацией</p>
                </div>
              </CardBody>
            </Card>
            </Link>
            <Link to="/data/program-of-practice-at-the-workplace-for-enterprises.rtf" text-decoration-none target="_blank">
            <Card>
              <CardBody>
                <div>
                  <p>Программа стажировки на рабочем месте_для предприятий</p>
                </div>
              </CardBody>
            </Card>
            </Link>
            <Link to="/data/internship-list-for-enterprises.rtf" text-decoration-none target="_blank">
            <Card>
              <CardBody>
                <div>
                  <p>Стажировочный лист для предприятий</p>
                </div>
              </CardBody>
            </Card>
            </Link>
            <Link to="/data/employment-contract-of-the-employer-with-an-intern.rtf" text-decoration-none target="_blank">
            <Card>
              <CardBody>
                <div>
                  <p>Трудовой договор работодателя со стажером</p>
                </div>
              </CardBody>
            </Card>
            </Link>
          </CardBody>
        </Card>
      </Animation>
    </div>
  );
}

export default Frame;